import { GenericLazyString, gettext } from '@eventbrite/i18n';

export const CATEGORY_FIXTURE = [
    {
        _type: 'tag',
        display_name: 'Film, Media & Entertainment',
        url: 'https://www.eventbrite.com/d/ny--new-york/film-and-media--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/104',
        id: '104',
        localized: {
            display_name: 'Film, Media & Entertainment',
        },
    },
    {
        _type: 'tag',
        display_name: 'Health & Wellness',
        url: 'https://www.eventbrite.com/d/ny--new-york/health--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/107',
        id: '107',
        localized: {
            display_name: 'Health & Wellness',
        },
    },
    {
        _type: 'tag',
        display_name: 'Hobbies & Special Interest',
        url: 'https://www.eventbrite.com/d/ny--new-york/hobbies--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/119',
        id: '119',
        localized: {
            display_name: 'Hobbies & Special Interest',
        },
    },
    {
        _type: 'tag',
        display_name: 'Family & Education',
        url: 'https://www.eventbrite.com/d/ny--new-york/family-and-education--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/115',
        id: '115',
        localized: {
            display_name: 'Family & Education',
        },
    },
    {
        _type: 'tag',
        display_name: 'Charity & Causes',
        url: 'https://www.eventbrite.com/d/ny--new-york/charity-and-causes--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/111',
        id: '111',
        localized: {
            display_name: 'Charity & Causes',
        },
    },
    {
        _type: 'tag',
        display_name: 'Sports & Fitness',
        url: 'https://www.eventbrite.com/d/ny--new-york/sports-and-fitness--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/108',
        id: '108',
        localized: {
            display_name: 'Sports & Fitness',
        },
    },
    {
        _type: 'tag',
        display_name: 'Fashion & Beauty',
        url: 'https://www.eventbrite.com/d/ny--new-york/fashion--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/106',
        id: '106',
        localized: {
            display_name: 'Fashion & Beauty',
        },
    },
    {
        _type: 'tag',
        display_name: 'Home & Lifestyle',
        url: 'https://www.eventbrite.com/d/ny--new-york/home-and-lifestyle--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/117',
        id: '117',
        localized: {
            display_name: 'Home & Lifestyle',
        },
    },
    {
        _type: 'tag',
        display_name: 'Religion & Spirituality',
        url: 'https://www.eventbrite.com/d/ny--new-york/spirituality--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/114',
        id: '114',
        localized: {
            display_name: 'Religion & Spirituality',
        },
    },
    {
        _type: 'tag',
        display_name: 'Science & Technology',
        url: 'https://www.eventbrite.com/d/ny--new-york/science-and-tech--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/102',
        id: '102',
        localized: {
            display_name: 'Science & Technology',
        },
    },
    {
        _type: 'tag',
        display_name: 'Travel & Outdoor',
        url: 'https://www.eventbrite.com/d/ny--new-york/travel-and-outdoor--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/109',
        id: '109',
        localized: {
            display_name: 'Travel & Outdoor',
        },
    },
    {
        _type: 'tag',
        display_name: 'Auto, Boat & Air',
        url: 'https://www.eventbrite.com/d/ny--new-york/auto-boat-and-air--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/118',
        id: '118',
        localized: {
            display_name: 'Auto, Boat & Air',
        },
    },
    {
        _type: 'tag',
        display_name: 'Seasonal & Holiday',
        url: 'https://www.eventbrite.com/d/ny--new-york/holiday--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/116',
        id: '116',
        localized: {
            display_name: 'Seasonal & Holiday',
        },
    },
    {
        _type: 'tag',
        display_name: 'Government & Politics',
        url: 'https://www.eventbrite.com/d/ny--new-york/government--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/112',
        id: '112',
        localized: {
            display_name: 'Government & Politics',
        },
    },
    {
        _type: 'tag',
        display_name: 'Other',
        url: 'https://www.eventbrite.com/d/ny--new-york/other--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/199',
        id: '199',
        localized: {
            display_name: 'Other',
        },
    },
];

export const PARTIAL_CATEGORY_FIXTURE = [
    {
        _type: 'tag',
        display_name: 'Film, Media & Entertainment',
        url: 'https://www.eventbrite.com/d/ny--new-york/film-and-media--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/104',
        id: '104',
        localized: {
            display_name: 'Film, Media & Entertainment',
        },
    },
    {
        _type: 'tag',
        display_name: 'Hobbies & Special Interest',
        url: 'https://www.eventbrite.com/d/ny--new-york/hobbies--events/',
        prefix: 'EventbriteCategory',
        tag: 'EventbriteCategory/119',
        id: '119',
        localized: {
            display_name: 'Hobbies & Special Interest',
        },
    },
];

export const CATEGORY_MAP: Record<
    string,
    { title: string | GenericLazyString; imageUrl: string }
> = {
    'EventbriteCategory/104': {
        title: gettext('Film, Media & Entertainment'),
        imageUrl:
            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F224206249%2F273095043669%2F1%2Foriginal.20220204-172935?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C324%2C1944%2C972&s=2bd018485a70c3a05cdb4bd39ac2a564',
    },
    'EventbriteCategory/119': {
        title: gettext('Hobbies & Special Interest'),
        imageUrl:
            'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F243008299%2F515788230677%2F1%2Foriginal.20220308-032436?w=800&auto=format%2Ccompress&q=75&sharp=10&rect=0%2C191%2C1544%2C772&s=cbdb9b20372f2ee09a237350d6b94c58',
    },
};
